import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postContract = data => {
  return dispatch => {
    dispatch({ type: "POST_CONTRACT_LOADING" });
    api
      .contractPost(data)
      .then(resp => {
        if (data.contract.contractId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "PostContractErrorAlertTitle",
          "Virhe työsopimuksen tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_CONTRACT_SUCCEEDED",
  payload: { contract: data },
});

const postEditSucceeded = data => ({
  type: "POST_CONTRACT_EDIT_SUCCEEDED",
  payload: { contract: data },
});

const operationFailed = () => ({
  type: "POST_CONTRACT_FAIL",
});
